// this is being used in webflow to persist the referral code into the session
export const REFERRAL_CODE_KEY = 'REFERRAL_CODE';

export const storeReferralCode = (code: string) => {
  localStorage.setItem(REFERRAL_CODE_KEY, code);
};

export const getReferralCode = () => {
  const params = new URLSearchParams(window.location.search);
  return (
    params.get('referralCode') ||
    localStorage.getItem(REFERRAL_CODE_KEY) ||
    undefined
  );
};
